export default "__VITE_ASSET__cIbIay3j__"